import { getCoordinateBounds } from 'libs/utils/world/worldUtils';
import { IWorldMarker } from 'react-give-me-map';
import { MapRef } from 'react-map-gl';

interface Params {
    mapRef: React.RefObject<MapRef>;
    defaultZoom: number;
    padding: number;
    offsetY?: number;
    animate: boolean;
    bearing: number;
    speed?: number;
}

export const useGoToMarker = ({
    mapRef,
    defaultZoom,
    padding,
    offsetY,
    animate,
    bearing,
    speed
}: Params) => {
    function goToMarker(marker: IWorldMarker) {
        if (marker && mapRef.current) {
            if (
                marker.elementType === 'text' ||
                marker.elementType === 'draw' ||
                marker.elementType === 'react' ||
                marker.elementType === 'v2/icon' ||
                marker.elementType === 'v2/variant_icon'
            ) {
                mapRef.current.flyTo({
                    center: {
                        lat: marker.lat,
                        lng: marker.lng
                    },
                    offset: [0, offsetY || 0],
                    speed: speed ?? 2,
                    zoom: defaultZoom,
                    animate: animate
                });
            } else if (marker.elementType === 'indoor_stand') {
                mapRef.current.flyTo({
                    center: {
                        lat: marker.lat,
                        lng: marker.lng
                    },
                    offset: [0, offsetY || 0],
                    zoom: defaultZoom,
                    animate
                });
            } else if (
                marker.elementType === 'direction' ||
                marker.elementType === 'v2/image' ||
                marker.elementType === 'route' ||
                marker.elementType === 'v2/line' ||
                marker.elementType === 'v2/polygon' ||
                marker.elementType === 'v2/wall' ||
                marker.elementType === 'v2/text' ||
                marker.elementType === 'v2/route'
            ) {
                const bounds = getCoordinateBounds(marker.elementData?.coordinates);

                mapRef.current?.fitBounds(bounds, {
                    padding,
                    offset: [0, offsetY || 0],
                    speed: speed ?? 2,
                    animate: true,
                    bearing
                });
            }
        }
    }

    return goToMarker;
};
